import { Forms } from "../../components/backgrounds/Forms";
import { Steps } from "../../components/buttons/Steps";
import { Primary } from "../../components/buttons/Primary";

export function ErrorPage() {
  return (
    <div className="bg-red bg-opacity-10">
      <Steps
        estado1="complete"
        estado2="complete"
        estado3="current"
        estado4="upcoming"
      />
      <Forms
        title="No pudimos procesar tu solicitud."
        description={"Ponte en contacto con nuestro equipo de servicio al cliente."}
        form={
          <div className="shadow-lg overflow-hidden rounded-md">
            <div className="px-4 py-5 bg-white sm:p-6">
              <div className="lg:px:4">
                <span>
                  Nuestro sistema ha procesado tu solicitud pero hemos presentado un error interno, por favor comunícate con nuestros agentes vía whatsapp en el botón que aparece en la esquina inferior derecha para que podamos revisar qué fue lo que pasó.
                </span>
              </div>
            </div>
            <div className="px-4 py-6 flex justify-end bg-white text-right sm:px-6">
              <a href="/" className="w-56 md:w-56">
                <Primary text="Volver" />
              </a>
            </div>
          </div>
        }
      />
    </div>
  );
}
